var BASWebServices;
(function (BASWebServices) {
    var CMDIOptions = (function () {
        function CMDIOptions($rootScope, ngDialog, $http, configService) {
            this.$rootScope = $rootScope;
            this.ngDialog = ngDialog;
            var cmdiLink = BASWebServices.ConfigService.GET_BAS_WEBSERVICES_CMDI_URL();
            var _rootScope = this.$rootScope;
            this.cmdiContentPromise = $http({
                method: 'GET',
                url: cmdiLink,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
            });
        }
        CMDIOptions.Factory = function ($rootScope, ngDialog, $http, configService) {
            return new CMDIOptions($rootScope, ngDialog, $http, configService);
        };
        CMDIOptions.prototype.getOptionsForServiceName = function (serviceName) {
            var _rootScope = this.$rootScope;
            var optionsForServiceName = this.cmdiContentPromise.then(function (response) {
                this.cmdiObject = $.xml2json(response.data, "").CMD;
                var allOperations = this.cmdiObject.Components.BASWebService.Service.Operations;
                var operation = BASWebServices.WebServiceCMDI.getOperation(allOperations, serviceName);
                var optionDiv = BASWebServices.ServiceOption.parseCMDIJSON(operation, serviceName);
                return optionDiv;
            })
                .catch(function (response) {
                CMDIOptions.errorOnCMDIPromise(response, _rootScope);
            });
            return optionsForServiceName;
        };
        CMDIOptions.prototype.getDeveloperInformationForServiceName = function (serviceName) {
            var _rootScope = this.$rootScope;
            var optionsForServiceName = this.cmdiContentPromise.then(function (response) {
                this.cmdiObject = $.xml2json(response.data, "").CMD;
                var allOperations = this.cmdiObject.Components.BASWebService.Service.Operations;
                var operation = BASWebServices.WebServiceCMDI.getOperation(allOperations, serviceName);
                if (!Array.isArray(operation.Developer.developerName)) {
                    operation.Developer.developerName = [operation.Developer.developerName];
                }
                if (!Array.isArray(operation.Developer.developerFundingOrg)) {
                    operation.Developer.developerFundingOrg = [operation.Developer.developerFundingOrg];
                }
                if (!Array.isArray(operation.Developer.developerCitation)) {
                    operation.Developer.developerCitation = [operation.Developer.developerCitation];
                }
                return operation.Developer;
            })
                .catch(function (response) {
                CMDIOptions.errorOnCMDIPromise(response, _rootScope);
            });
            return optionsForServiceName;
        };
        CMDIOptions.prototype.getNecessaryParameters = function (serviceName) {
            var _rootScope = this.$rootScope;
            var optionsForServiceName = this.cmdiContentPromise.then(function (response) {
                this.cmdiObject = $.xml2json(response.data, "").CMD;
                var allOperations = this.cmdiObject.Components.BASWebService.Service.Operations;
                var operation = BASWebServices.WebServiceCMDI.getOperation(allOperations, serviceName);
                var necessaryParams = new Array();
                for (var i = 0; i < operation.Input.Parameter.length; i++) {
                    var currentParam = operation.Input.Parameter[i];
                    if (currentParam.isConfigurationParameter == "false") {
                        necessaryParams.push(currentParam.Name);
                    }
                }
                return necessaryParams;
            })
                .catch(function (response) {
                CMDIOptions.errorOnCMDIPromise(response, _rootScope);
            });
            return optionsForServiceName;
        };
        CMDIOptions.prototype.getDescriptionForOperationNameAndParamName = function (serviceName, paramName) {
            var _rootScope = this.$rootScope;
            var optionsForServiceName = this.cmdiContentPromise.then(function (response) {
                this.cmdiObject = $.xml2json(response.data, "").CMD;
                var allOperations = this.cmdiObject.Components.BASWebService.Service.Operations;
                var operation = BASWebServices.WebServiceCMDI.getOperation(allOperations, serviceName);
                for (var i = 0; i < operation.Input.Parameter.length; i++) {
                    var currentParameter = operation.Input.Parameter[i];
                    if (currentParameter.Name.lastIndexOf(paramName) != -1) {
                        return currentParameter.Description;
                    }
                }
            })
                .catch(function (response) {
                CMDIOptions.errorOnCMDIPromise(response, _rootScope);
            });
            return optionsForServiceName;
        };
        CMDIOptions.prototype.deleteLanguagesFromServiceOptions = function (serviceName) {
            for (var i = 0; this.cmdiObject.Components.BASWebService.Service.Operations.Operation.length; i++) {
                var operation = this.cmdiObject.Components.BASWebService.Service.Operations.Operation[i];
                if (operation.Name == serviceName) {
                    console.log("operation name equals service name");
                }
            }
        };
        CMDIOptions.prototype.getAllServiceNames = function () {
            var _rootScope = this.$rootScope;
            var serviceNames = this.cmdiContentPromise.then(function (response) {
                this.cmdiObject = $.xml2json(response.data, "").CMD;
                var allOperations = this.cmdiObject.Components.BASWebService.Service.Operations;
                var serviceNames = [];
                for (var operationIndex in allOperations.Operation) {
                    var operation = allOperations.Operation[operationIndex];
                    serviceNames.push(operation.Name);
                }
                return serviceNames;
            })
                .catch(function (response) {
                CMDIOptions.errorOnCMDIPromise(response, _rootScope);
            });
            return serviceNames;
        };
        CMDIOptions.prototype.getDescriptionForOperationName = function (serviceName) {
            var _rootScope = this.$rootScope;
            var descriptionForServiceName = this.cmdiContentPromise.then(function (response) {
                this.cmdiObject = $.xml2json(response.data, "").CMD;
                var allOperations = this.cmdiObject.Components.BASWebService.Service.Operations;
                var operation = BASWebServices.WebServiceCMDI.getOperation(allOperations, serviceName);
                return operation.Description;
            })
                .catch(function (response) {
                CMDIOptions.errorOnCMDIPromise(response, _rootScope);
            });
            return descriptionForServiceName;
        };
        CMDIOptions.prototype.getClosedVocabularyForOperationAndOptionName = function (serviceName, optionName) {
            var _rootScope = this.$rootScope;
            var valuesOfOptionOfService = this.cmdiContentPromise.then(function (response) {
                this.cmdiObject = $.xml2json(response.data, "").CMD;
                var allOperations = this.cmdiObject.Components.BASWebService.Service.Operations;
                var operation = BASWebServices.WebServiceCMDI.getOperation(allOperations, serviceName);
                console.log("blaaaaaaaaaaaaaaaaaa");
                console.log("bla");
                if (operation.Input.Parameter.length != null) {
                    for (var i = 0; i < operation.Input.Parameter.length; i++) {
                        var currentParameter = operation.Input.Parameter[i];
                        console.log("CurrParamName: " + currentParameter.Name + " | Searching: " + optionName);
                        if (currentParameter.Name.lastIndexOf(optionName) != -1) {
                            return currentParameter.Values;
                        }
                    }
                }
                else {
                    var param = operation.Input.Parameter;
                    return param.Values;
                }
            })
                .catch(function (response) {
                CMDIOptions.errorOnCMDIPromise(response, _rootScope);
            });
            return valuesOfOptionOfService;
        };
        CMDIOptions.errorOnCMDIPromise = function (response, _rootScope) {
            var data = response.data;
            var status = response.status;
            console.error('SEVERE', 'Backend server was unreachable (please inform developer)');
            _rootScope.$broadcast('messageForBox', 'ERROR', 'Backend server was unreachable (please inform developer)', "Data: " + data + " | Status: " + status);
        };
        return CMDIOptions;
    }());
    BASWebServices.CMDIOptions = CMDIOptions;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=CMDIOptions.js.map